import styled from 'styled-components';

export const StyledMenLikeMePage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-height: 100vh;
  ${(props) =>
    props.isBlurred &&
    `
    filter: blur(5px);
    -webkit-filter: blur(5px);
    -moz-filter: blur(5px);
    -ms-filter: blur(5px);
    -o-filter: blur(5px);
    filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='5');
  `};
`;

export const StyledHeadingContainer = styled.div`
  justify-self: center;
  padding: 100px;
`;
